// extracted by mini-css-extract-plugin
module.exports = {"container":"LoyaltyPrograms_container___ho1c","section":"LoyaltyPrograms_section__p_VtS"};